import { render, staticRenderFns } from "./GStudentRecordTrendScoreTransition.vue?vue&type=template&id=f0ac75e8&scoped=true&"
import script from "./GStudentRecordTrendScoreTransition.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordTrendScoreTransition.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordTrendScoreTransition.vue?vue&type=style&index=0&id=f0ac75e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ac75e8",
  null
  
)

export default component.exports